import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/Game/GameModel';
import { BonusLogic } from './BonusLogic';
import { BonusTypeEnum } from '../../Models/Game/BonusModel';
import { rangeRandomInt } from '../../Common/Utils';
import { TaskType } from '../../Models/Game/TaskModel';

import BonusContants from '../../Constants/BonusContants';
import { GameLogic } from '../GameLogic';

@Singleton
export class BonusClockLogic extends BonusLogic {
    private _time: number = 0;

    constructor(
        @Inject private _model: GameModel,
        @Inject private _modelEvents: ModelEvents
    ) {
        super();

        this._config = BonusContants.find(o => o.type === BonusTypeEnum.clock);
    }

    public apply(gameLogic: GameLogic): void {
        super.apply(gameLogic);

        this._time = rangeRandomInt(
            this._config.props.freezeTime[0],
            this._config.props.freezeTime[1]
        );
        this._gameLogic
            .getActiveTasks()
            .where(o => o.type === TaskType.Regular)
            .forEach(o => (o.pause = true));
    }

    public cancel(): void {
        super.cancel();

        this._gameLogic
            .getActiveTasks()
            .where(o => o.type === TaskType.Regular)
            .forEach(o => (o.pause = false));

        this._time = 0;
    }

    public destroy(): void {
        super.destroy();

        this._time = 0;
    }

    public update(frameTime: number): void {
        if (this._time > 0) {
            this._time = Math.max(0, this._time - frameTime);
        } else if (this._active) {
            this.cancel();
        }
    }

    public getTime(): number {
        return this._time;
    }
}
